export const THEME_OPTIONS = [
  { label: 'Default', value: 'default' },
  { label: 'Dark', value: 'dark' },
];
